/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-06-20 09:41:35
 * @LastEditors: hongye
 * @LastEditTime: 2026-04-10 10:05:40
 */
import { RouteRecordRaw } from 'vue-router'
import { NameEnum, UrlEnum, UnionEnum } from '@/utils/enums/Route'
const StaffManage = () => import('@/views/staffManage/Index.vue')
const Announcement = () => import('@/views/announcement/Index.vue')
const FeedBack = () => import('@/views/feedback/Index.vue')
const OperateAccountManage = () => import('@/views/operateAccountManage/Index.vue')
const RoleManage = () => import('@/views/roleManage/Index.vue')
const MenuManage = () => import('@/views/menuManage/Index.vue')
const DataDictionary = () => import('@/views/dataDictionary/Index.vue')
const AgencyAreaList = () => import('@/views/agencyAreaList/Index.vue')
const ExpressCompanyManage = () => import('@/views/expressCompanyManage/Index.vue')
const SmsRecord = () => import('@/views/smsRecord/Index.vue')
const SmsTemplate = () => import('@/views/smsTemplate/Index.vue')
const CustomerManagement = () => import('@/views/CustomerManagement/Index.vue')
const CodStatistics = () => import('@/views/codStatistics/Index.vue')
const AccountManage = () => import('@/views/enterpriseBank/accountManagement/index.vue')
const AdvanceManage = () => import('@/views/enterpriseBank/advanceManagement/index.vue')
const AuditManage = () => import('@/views/enterpriseBank/auditManagement/index.vue')
const AdvanceInquiry = () => import('@/views/enterpriseBank/advanceInquiry/index.vue')
const failureManagement = () => import('@/views/enterpriseBank/failureManagement/index.vue')
const feeTypeManagement = () => import('@/views/basicParams/feeTypeManagement/Index.vue')

// COD统计
const codStatisticsManage: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.CODSTATISTICS],
    name: 'CodStatistics',
    component: CodStatistics,
    meta: { title: NameEnum[UnionEnum.CODSTATISTICS], requiresAuth: true, keepAlive: true }
  },
  // 异常支付审核
  {
    path: UrlEnum[UnionEnum.ABNORMALPAYMENT],
    name: 'AbnormalPayment',
    component: () => import('@/views/codStatistics/abnormalPayment/Index.vue'),
    meta: { title: NameEnum[UnionEnum.ABNORMALPAYMENT], requiresAuth: true, keepAlive: true }
  }
]

// 包裹管理
const packManage: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.DISPATCHLIST],
    name: 'DispatchList',
    component: () => import('@/views/packageManagement/dispatchList/Index.vue'),
    meta: { title: NameEnum[UnionEnum.DISPATCHLIST], requiresAuth: true, keepAlive: true }
  },
  {
    path: '/inquiryList',
    name: 'InquiryList',
    component: () => import('@/views/packageManagement/inquiryList/Index.vue'),
    meta: { title: '客户问询列表', requiresAuth: false, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.SHIPPINGLIST],
    name: 'ShippingList',
    component: () => import('../views/packageManagement/shippingList/Index.vue'),
    meta: { title: NameEnum[UnionEnum.SHIPPINGLIST], requiresAuth: false, keepAlive: true }
  }
]
//运营管理
const operateManage: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.SITELIST],
    name: 'SiteList',
    component: () => import('../views/operateAccountManage/siteList/Index.vue'),
    meta: { title: NameEnum[UnionEnum.SITELIST], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.REVIEWLIST],
    name: 'ReviewList',
    component: () => import('../views/operateAccountManage/reviewList/Index.vue'),
    meta: { title: NameEnum[UnionEnum.REVIEWLIST], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.STAFFMANAGER],
    name: 'StaffManage',
    component: StaffManage,
    meta: { title: NameEnum[UnionEnum.STAFFMANAGER], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.CUSTOMERMANAGEMENT],
    name: 'CustomerManagement',
    component: CustomerManagement,
    meta: { title: NameEnum[UnionEnum.CUSTOMERMANAGEMENT], requiresAuth: true, keepAlive: true }
  },
  {
    path: '/pinSearch',
    name: 'PinSearch',
    component: () => import('@/views/packageManagement/dispatchList/pinSearch.vue'),
    meta: { title: 'PIN码查询', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/willingnessManagement',
    name: 'WillingnessManagement',
    component: () => import('@/views/WillingnessManagement/Index.vue'),
    meta: { title: 'YoYi用户意愿管理', requiresAuth: true, keepAlive: true }
  }
]

// 管理中心
const manageCenter: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.ANNOUNCEMENTLIST],
    name: 'Announcement',
    component: Announcement,
    meta: { title: NameEnum[UnionEnum.ANNOUNCEMENTLIST], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.FEEDBACK],
    name: 'FeedBack',
    component: FeedBack,
    meta: { title: NameEnum[UnionEnum.FEEDBACK], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.OPERATEACCOUNTMANAGE],
    name: 'OperateAccountManage',
    component: OperateAccountManage,
    meta: { title: NameEnum[UnionEnum.OPERATEACCOUNTMANAGE], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.ROLEMANAGE],
    name: 'RoleManage',
    component: RoleManage,
    meta: { title: NameEnum[UnionEnum.ROLEMANAGE], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.MENUMANAGE],
    name: 'MenuManage',
    component: MenuManage,
    meta: { title: NameEnum[UnionEnum.MENUMANAGE], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.DATADICTIONARY],
    name: 'DataDictionary',
    component: DataDictionary,
    meta: { title: NameEnum[UnionEnum.DATADICTIONARY], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.AGENCYAREALIST],
    name: 'AgencyAreaList',
    component: AgencyAreaList,
    meta: { title: NameEnum[UnionEnum.AGENCYAREALIST], requiresAuth: true, keepAlive: true }
  },
  {
    path: '/agentBusiness',
    name: 'AgentBusiness',
    component: () => import('@my/views/manageCenter/agentBusiness/agentBusiness.vue'),
    meta: { title: '代理商维护', requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.EXPRESSCOMPANYMANAGE],
    name: 'ExpressCompanyManage',
    component: ExpressCompanyManage,
    meta: { title: NameEnum[UnionEnum.EXPRESSCOMPANYMANAGE], requiresAuth: true, keepAlive: true }
  },
  {
    path: '/holidays',
    name: 'Holidays',
    component: () => import('@/views/manageCenter/holidays/holidays.vue'),
    meta: { title: '节假日维护', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/yoyiInformation',
    name: 'YoyiInformation',
    component: () => import('../views/manageCenter/yoyiInformation/yoyiInformation.vue'),
    meta: { title: '信息发送管理', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/invoicingInfo',
    name: 'InvoicingInfo',
    component: () => import('../views/manageCenter/invoiceInfor/invoiceInfor.vue'),
    meta: { title: '开票信息维护', requiresAuth: true, keepAlive: true }
  }
]

//短信管理
const smsManagement: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.SMSRECORD],
    name: 'SmsRecord',
    component: SmsRecord,
    meta: { title: NameEnum[UnionEnum.SMSRECORD], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.SMSTEMPLATE],
    name: 'SmsTemplate',
    component: SmsTemplate,
    meta: { title: NameEnum[UnionEnum.SMSTEMPLATE], requiresAuth: true, keepAlive: true }
  }
]
//财务结算
const financialSettlement: RouteRecordRaw[] = [
  {
    path: '/groupMaintenanceOfDispatchStations',
    name: 'GroupMaintenanceOfDispatchStations',
    component: () => import('../views/financial-settlement/group-maintenance-of-dispatch-stations/index.vue'),
    meta: { title: '派件驿站分组维护', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/agentMappingMaintenance',
    name: 'AgentMappingMaintenance',
    component: () => import('../views/financial-settlement/agent-mapping-maintenance/index.vue'),
    meta: { title: '代理商映射维护', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/dispatchBillManagement',
    name: 'DispatchBillManagement',
    component: () => import('../views/financial-settlement/dispatch-bill-management/index.vue'),
    meta: { title: '派件费账单管理', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/deliveryFeeQuote',
    name: 'DeliveryFeeQuote',
    component: () => import('../views/financial-settlement/dispatch-fee-quote/index.vue'),
    meta: { title: '派件费报价维护', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/deliveryFeeQuoteAudit',
    name: 'DeliveryFeeQuoteAudit',
    component: () => import('../views/financial-settlement/dispatch-fee-quote/audit.vue'),
    meta: { title: '派件费报价审核', requiresAuth: true, keepAlive: true }
  }
]
const financialReport: RouteRecordRaw[] = [
  {
    path: '/selfInvoiceReport',
    name: 'SelfInvoiceReport',
    component: () => import('../views/financial-report/self-invoice-report/index.vue'),
    meta: { title: '自开票数据汇总', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/addDeductReport',
    name: 'AddDeductReport',
    component: () => import('../views/financial-report/add-deduct-report/index.vue'),
    meta: { title: '加扣款数据汇总', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/franchiseeReport',
    name: 'FranchiseeReport',
    component: () => import('../views/financial-report/franchisee-report/index.vue'),
    meta: { title: '加盟商对账单', requiresAuth: true, keepAlive: true }
  }
]
//任务中心
const taskCenter: RouteRecordRaw[] = [
  {
    path: '/billLockManagement',
    name: 'BillLockManagement',
    component: () => import('../views/task-center/bill-lock-management/index.vue'),
    meta: { title: '账单锁账管理', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/taskList',
    name: 'TaskList',
    component: () => import('../views/task-center/task-list/taskList.vue'),
    meta: { title: '算费任务列表', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/importTaskQuery',
    name: 'ImportTaskQuery',
    component: () => import('../views/task-center/import-task-query/index.vue'),
    meta: { title: '导入任务查询', requiresAuth: true, keepAlive: true }
  }
]
// 企业银行
const enterpriseBank: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.ACCOUNT_MANAGEMENT],
    name: 'AccountManagement',
    component: AccountManage,
    meta: { title: NameEnum[UnionEnum.ACCOUNT_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 1 }
  },
  {
    path: UrlEnum[UnionEnum.COD_ACCOUNT_MANAGEMENT],
    name: 'CodAccountManagement',
    component: AccountManage,
    meta: { title: NameEnum[UnionEnum.COD_ACCOUNT_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 2 }
  },
  {
    path: UrlEnum[UnionEnum.ADVANCE_MANAGEMENT],
    name: 'AdvanceManagement',
    component: AdvanceManage,
    meta: { title: NameEnum[UnionEnum.ADVANCE_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 1 }
  },
  {
    path: UrlEnum[UnionEnum.COD_ADVANCE_MANAGEMENT],
    name: 'CodAdvanceManagement',
    component: AdvanceManage,
    meta: { title: NameEnum[UnionEnum.COD_ADVANCE_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 2 }
  },
  {
    path: UrlEnum[UnionEnum.AUDIT_MANAGEMENT],
    name: 'AuditManagement',
    component: AuditManage,
    meta: { title: NameEnum[UnionEnum.AUDIT_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 1 }
  },
  {
    path: UrlEnum[UnionEnum.COD_AUDIT_MANAGEMENT],
    name: 'CodAuditManagement',
    component: AuditManage,
    meta: { title: NameEnum[UnionEnum.COD_AUDIT_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 2 }
  },
  {
    path: UrlEnum[UnionEnum.ADVANCE_INQUIRY],
    name: 'AdvanceInquiry',
    component: AdvanceInquiry,
    meta: { title: NameEnum[UnionEnum.ADVANCE_INQUIRY], requiresAuth: true, keepAlive: true, prepaidType: 1 }
  },
  {
    path: UrlEnum[UnionEnum.COD_ADVANCE_INQUIRY],
    name: 'CodAdvanceInquiry',
    component: AdvanceInquiry,
    meta: { title: NameEnum[UnionEnum.COD_ADVANCE_INQUIRY], requiresAuth: true, keepAlive: true, prepaidType: 2 }
  },
  {
    path: UrlEnum[UnionEnum.FAILURE_MANAGEMENT],
    name: 'FailureManagement',
    component: failureManagement,
    meta: { title: NameEnum[UnionEnum.FAILURE_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 1 }
  },
  {
    path: UrlEnum[UnionEnum.COD_FAILURE_MANAGEMENT],
    name: 'CodFailureManagement',
    component: failureManagement,
    meta: { title: NameEnum[UnionEnum.COD_FAILURE_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 2 }
  },
  {
    path: UrlEnum[UnionEnum.FEE_TYPE_MANAGEMENT],
    name: 'FeeTypeManagement',
    component: feeTypeManagement,
    meta: { title: NameEnum[UnionEnum.FEE_TYPE_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 1 }
  },
  {
    path: UrlEnum[UnionEnum.COD_FEE_TYPE_MANAGEMENT],
    name: 'CodFeeTypeManagement',
    component: feeTypeManagement,
    meta: { title: NameEnum[UnionEnum.COD_FEE_TYPE_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 2 }
  }
]
const configManagement: RouteRecordRaw[] = [
  {
    path: '/podConfig',
    name: 'PodConfig',
    component: () => import('../views/configManagement/podConfig/podConfig.vue'),
    meta: { title: 'POD配置', requiresAuth: true, keepAlive: true }
  }
]
export {
  codStatisticsManage,
  packManage,
  operateManage,
  manageCenter,
  smsManagement,
  financialSettlement,
  financialReport,
  taskCenter,
  enterpriseBank,
  configManagement
}
